import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { Valuation } from '../../types/events.types';
import { Company } from '../index';
import { useAppQuery } from '../use-app-query.hook';

export const useValuation = ({ id }: { id: string }) => {
  const queryClient = useQueryClient();
  const { selectedCompanyId: companyId } = Company.useSelected();

  const { data: valuation, isPending } = useAppQuery({
    queryKey: [QueryKey.GET_VALUATION, companyId, id],
    queryFn: () =>
      ApiService.get<Valuation>({
        endpoint: BackendRoute.COMPANIES,
        routePath: [companyId, 'events', 'valuations', id],
      }),
    enabled: !!companyId && !!id,
  });

  const invalidateQuery = useCallback(() => {
    queryClient.invalidateQueries({ queryKey: [QueryKey.GET_VALUATION] });
  }, [queryClient]);

  return {
    invalidateQuery,
    valuation,
    isPending,
  };
};
